export const InfoCircleFilledIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.85183 15.1111C11.7792 15.1111 14.9629 11.9274 14.9629 8.00003C14.9629 4.07267 11.7792 0.888916 7.85183 0.888916C3.92448 0.888916 0.740723 4.07267 0.740723 8.00003C0.740723 11.9274 3.92448 15.1111 7.85183 15.1111ZM8.91849 4.44419C8.91849 5.03329 8.44093 5.51086 7.85182 5.51086C7.26272 5.51086 6.78516 5.03329 6.78516 4.44419C6.78516 3.85509 7.26272 3.37752 7.85182 3.37752C8.44093 3.37752 8.91849 3.85509 8.91849 4.44419ZM6.78517 6.87772C6.78517 6.71203 6.91949 6.57772 7.08517 6.57772H8.61851C8.78419 6.57772 8.91851 6.71203 8.91851 6.87772V12.5987C8.91851 12.7644 8.78419 12.8987 8.61851 12.8987H7.08517C6.91949 12.8987 6.78517 12.7644 6.78517 12.5987V6.87772Z"
      fill="black"
      fillOpacity="0.6"
    />
  </svg>
);
